import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox as MuiCheckbox, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: (props) => ({
    color: props.borderColor,
    '& svg': {
      width: props.size,
      height: props.size,
    },
  }),
  checked: (props) => ({ color: props.checkedColor }),
});

const StyledCheckbox = ({ borderColor, checkedColor, size = 28, ...props }) => {
  const classes = useStyles({ borderColor, checkedColor, size });
  return <MuiCheckbox classes={classes} color={checkedColor ? 'default' : 'primary'} {...props} />;
};

const Checkbox = ({ color, borderColor, checkedColor, checked, size, ...props }) => {
  return (
    <StyledCheckbox
      borderColor={borderColor || color}
      checkedColor={checkedColor || color}
      checked={checked}
      size={size}
      {...props}
    />
  );
};

StyledCheckbox.propTypes = {
  borderColor: PropTypes.string,
  checkedColor: PropTypes.string,
  size: PropTypes.number,
};

Checkbox.propTypes = {
  color: PropTypes.string,
  borderColor: PropTypes.string,
  checkedColor: PropTypes.string,
  size: PropTypes.number,
  checked: PropTypes.bool,
};

export default Checkbox;
